/**
 * Returns true if `value` is a safe root-relative path that can be passed
 * directly to TanStack Router's navigate/redirect without a full page reload.
 *
 * A leading slash is required and the resolved URL must share the current
 * origin to prevent open redirect attacks (e.g. `//evil.com`, `/\evil.com`).
 * Uses the browser's URL parser as the source of truth so normalization
 * edge-cases (backslash, encoded characters) are handled correctly.
 */
export const isInternalPath = (value: string): boolean => {
  if (!value.startsWith("/") || value.startsWith("//")) {
    return false;
  }

  try {
    const resolved = new URL(value, globalThis.location.origin);
    return resolved.origin === globalThis.location.origin;
  } catch {
    return false;
  }
};
